(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', class extends HTMLElement {
      connectedCallback() {
        this.messages = Array.prototype.slice.call(this.querySelectorAll('[data-announcement-slides] > [data-announcement-message]'));
        this.index = 0;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = (parseInt(this.dataset.interval, 10) || 5) * 1000;
        var self = this;
        if (this.classList.contains('announcement--rotate')) {
          this.show(0, true);
        } else {
          this.messages.forEach(function (message) { message.classList.add('is-active'); });
        }
        this.addEventListener('click', function (event) {
          if (event.target.closest('[data-announcement-next]')) self.go(1);
          if (event.target.closest('[data-announcement-prev]')) self.go(-1);
          if (event.target.closest('[data-announcement-close]')) self.dismiss();
        });
        ['mouseenter', 'focusin'].forEach(function (type) { self.addEventListener(type, function () { self.paused = true; }); });
        ['mouseleave', 'focusout'].forEach(function (type) { self.addEventListener(type, function () { self.paused = false; }); });
        this.start();
      }

      disconnectedCallback() { clearInterval(this.timer); }

      start() {
        clearInterval(this.timer);
        if (this.messages.length < 2 || this.reduce || !this.classList.contains('announcement--rotate')) return;
        var self = this;
        this.timer = setInterval(function () { if (!self.paused && !document.hidden) self.go(1); }, this.interval);
      }

      go(step) {
        if (this.messages.length < 2) return;
        this.show((this.index + step + this.messages.length) % this.messages.length);
      }

      show(index, instant) {
        var self = this;
        this.messages.forEach(function (message, i) {
          var active = i === index;
          message.classList.toggle('is-active', active);
          message.classList.toggle('is-leaving', !active && i === self.index && !instant);
          message.setAttribute('aria-hidden', active ? 'false' : 'true');
          message.querySelectorAll('a').forEach(function (link) { link.tabIndex = active ? 0 : -1; });
        });
        this.index = index;
      }

      dismiss() {
        var key = this.dataset.storageKey;
        try { sessionStorage.setItem(key, '1'); } catch (error) {}
        var self = this;
        this.classList.add('is-dismissing');
        setTimeout(function () { self.hidden = true; }, 350);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    document.addEventListener('cart:updated', function (event) {
      var detail = event.detail || {};
      if (detail.source !== 'add' || !detail.items) return;
      requestAnimationFrame(function () {
        detail.items.forEach(function (item, index) {
          var line = document.querySelector('#CartDrawer [data-line-key="' + item.key + '"]');
          if (!line) return;
          line.style.setProperty('--i', index);
          line.classList.add('is-entering');
        });
      });
    });

    document.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-line-remove]');
      if (remove) {
        var line = remove.closest('.cart-line');
        if (line) line.classList.add('is-removing');
        return;
      }
      var minus = event.target.closest('[data-line-step="-1"]');
      if (minus) {
        var owner = minus.closest('.cart-line');
        var input = owner && owner.querySelector('[data-line-quantity]');
        if (input) setTimeout(function () { if (parseInt(input.value, 10) <= 0) owner.classList.add('is-removing'); }, 0);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function focusMessage(scope) {
      var message = (scope || document).querySelector('[data-contact-success], [data-contact-errors]');
      if (message) message.focus({ preventScroll: false });
    }
    document.addEventListener('DOMContentLoaded', function () { focusMessage(); });
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-contact-form]');
      if (!form) return;
      var email = form.querySelector('input[type="email"]');
      var body = form.querySelector('textarea');
      var invalid = [email, body].filter(function (field) { return field && !field.checkValidity(); });
      [email, body].forEach(function (field) { if (field) field.removeAttribute('aria-invalid'); });
      if (invalid.length) {
        event.preventDefault();
        invalid.forEach(function (field) { field.setAttribute('aria-invalid', 'true'); });
        invalid[0].focus();
        return;
      }
      var button = form.querySelector('[type="submit"]');
      if (button) {
        if (button.classList.contains('is-loading')) { event.preventDefault(); return; }
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-gallery')) {
    customElements.define('featured-gallery', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.fp__rail');
        this.slides = Array.from(this.querySelectorAll('.fp__slide'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.current = this.querySelector('[data-gallery-current]');
        if (!this.rail || this.slides.length < 2) return;
        this.onScroll = this.onScroll.bind(this);
        this.rail.addEventListener('scroll', this.onScroll, { passive: true });
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.go(parseInt(thumb.dataset.thumb, 10))));
        this.rail.addEventListener('keydown', (event) => {
          var rtl = getComputedStyle(this.rail).direction === 'rtl';
          if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + (rtl ? -1 : 1)); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index + (rtl ? 1 : -1)); }
        });
        var root = this.closest('[data-product-root]');
        if (root) {
          root.addEventListener('media:select', (event) => {
            var slide = this.slides.find((item) => item.dataset.mediaId === String(event.detail.mediaId));
            if (slide) this.go(parseInt(slide.dataset.index, 10));
          });
        }
        this.index = 0;
      }
      go(index) {
        index = Math.max(0, Math.min(this.slides.length - 1, index));
        var slide = this.slides[index];
        var railBox = this.rail.getBoundingClientRect();
        var slideBox = slide.getBoundingClientRect();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollBy({ left: slideBox.left - railBox.left, behavior: reduce ? 'auto' : 'smooth' });
        this.setActive(index);
      }
      onScroll() {
        var railBox = this.rail.getBoundingClientRect();
        var closest = 0;
        var distance = Infinity;
        this.slides.forEach((slide, i) => {
          var gap = Math.abs(slide.getBoundingClientRect().left - railBox.left);
          if (gap < distance) { distance = gap; closest = i; }
        });
        this.setActive(closest);
      }
      setActive(index) {
        if (index === this.index) return;
        this.index = index;
        if (this.current) this.current.textContent = index + 1;
        this.thumbs.forEach((thumb, i) => {
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function headerEl() { return document.querySelector('[data-header]'); }

    function measure() {
      var header = headerEl();
      if (!header) return;
      document.documentElement.style.setProperty('--header-height', Math.round(header.getBoundingClientRect().height) + 'px');
    }

    function setup() {
      var header = headerEl();
      if (!header || header.dataset.headerReady) return;
      header.dataset.headerReady = 'true';
      measure();
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);

      var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      var openItem = null;
      var closeTimer = null;
      var openTimer = null;

      function panelOf(item) { return item.querySelector('[data-panel]'); }
      function toggleOf(item) { return item.querySelector('[data-panel-toggle]'); }

      function open(item) {
        clearTimeout(closeTimer);
        if (openItem && openItem !== item) close(openItem, true);
        var panel = panelOf(item);
        panel.hidden = false;
        requestAnimationFrame(function () { panel.classList.add('is-open'); });
        toggleOf(item).setAttribute('aria-expanded', 'true');
        header.classList.add('has-open-panel');
        openItem = item;
      }

      function close(item, instant) {
        var panel = panelOf(item);
        toggleOf(item).setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
        if (openItem === item) openItem = null;
        if (!openItem) header.classList.remove('has-open-panel');
        if (instant) { panel.hidden = true; return; }
        setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 350);
      }

      header.querySelectorAll('[data-menu-item]').forEach(function (item) {
        var toggle = toggleOf(item);
        toggle.addEventListener('click', function () {
          if (toggle.getAttribute('aria-expanded') === 'true') close(item); else open(item);
        });
        item.addEventListener('pointerenter', function (event) {
          if (event.pointerType !== 'mouse' || !fine.matches) return;
          clearTimeout(closeTimer);
          clearTimeout(openTimer);
          openTimer = setTimeout(function () { open(item); }, 90);
        });
        item.addEventListener('pointerleave', function (event) {
          if (event.pointerType !== 'mouse' || !fine.matches) return;
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () { close(item); }, 180);
        });
        item.addEventListener('focusout', function (event) {
          if (!item.contains(event.relatedTarget)) close(item);
        });
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
            event.stopPropagation();
            close(item);
            toggle.focus();
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (openItem && !openItem.contains(event.target)) close(openItem);
      });
    }

    document.addEventListener('dialog:open', function (event) {
      if (event.target.id === 'MenuDrawer') document.querySelectorAll('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    });
    document.addEventListener('dialog:close', function (event) {
      if (event.target.id === 'MenuDrawer') document.querySelectorAll('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });

    document.addEventListener('click', function (event) {
      var search = event.target.closest('[data-menu-search]');
      if (!search) return;
      event.preventDefault();
      var menu = document.getElementById('MenuDrawer');
      if (menu && menu.open) menu.close();
      if (window.Aroma && document.getElementById('SearchDialog')) {
        setTimeout(function () { window.Aroma.openDialog('SearchDialog', search); }, 60);
      } else {
        window.location.href = search.href;
      }
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
    document.addEventListener('shopify:section:load', function () { setup(); measure(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-share-url]');
    if (!button || !navigator.share) return;
    navigator.share({ title: button.dataset.shareTitle, url: button.dataset.shareUrl }).catch(function () {});
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (!navigator.share) return;
    document.querySelectorAll('.main-article__native-share').forEach(function (button) { button.hidden = false; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.gallery__track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('.gallery__dot'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb-for]'));
        this.index = 0;
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.goToMedia(thumb.getAttribute('data-thumb-for')));
        });
        this.track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const forward = (event.key === 'ArrowRight') !== rtl;
          this.goTo(this.index + (forward ? 1 : -1));
        });
        const root = this.closest('[data-product-root]');
        if (root) {
          this.onMediaSelect = (event) => this.goToMedia(event.detail && event.detail.mediaId, true);
          root.addEventListener('media:select', this.onMediaSelect);
          this.root = root;
        }
      }

      disconnectedCallback() {
        if (this.root && this.onMediaSelect) this.root.removeEventListener('media:select', this.onMediaSelect);
      }

      onScroll() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const width = this.track.clientWidth || 1;
          const index = Math.round(Math.abs(this.track.scrollLeft) / width);
          this.setActive(Math.max(0, Math.min(this.slides.length - 1, index)));
        });
      }

      setActive(index) {
        if (index === this.index) return;
        this.index = index;
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        const activeSlide = this.slides[index];
        const id = activeSlide && activeSlide.getAttribute('data-media-id');
        this.thumbs.forEach((thumb) => {
          const on = thumb.getAttribute('data-thumb-for') === id;
          thumb.classList.toggle('is-active', on);
          if (on) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
        });
        this.slides.forEach((slide, i) => {
          const video = slide.querySelector('video');
          if (video && i !== index) video.pause();
        });
      }

      goTo(index) {
        const clamped = Math.max(0, Math.min(this.slides.length - 1, index));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const left = clamped * this.track.clientWidth * (rtl ? -1 : 1);
        this.track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      }

      goToMedia(id, fromVariant) {
        if (!id) return;
        const index = this.slides.findIndex((slide) => slide.getAttribute('data-media-id') === String(id));
        if (index === -1) return;
        this.goTo(index);
        if (!fromVariant) this.track.focus({ preventScroll: true });
      }
    });
  }

  if (!customElements.get('sticky-buy-bar')) {
    customElements.define('sticky-buy-bar', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('[data-product-root]');
        this.target = this.root && this.root.querySelector('[data-main-buy]');
        if (!this.target) return;
        this.footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('body > footer');
        this.visible = false;
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.onVariant = (event) => { this.syncPickers(event); requestAnimationFrame(() => this.update()); };
        if (this.root) this.root.addEventListener('variant:change', this.onVariant);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.root) this.root.removeEventListener('variant:change', this.onVariant);
        document.documentElement.style.removeProperty('--toast-offset');
      }

      update() {
        const buy = this.target.getBoundingClientRect();
        const footerTop = this.footer ? this.footer.getBoundingClientRect().top : Infinity;
        const add = this.querySelector('[data-add-button]');
        const buyable = !add || !add.disabled;
        const show = buyable && buy.bottom < 0 && footerTop > window.innerHeight && !document.querySelector('dialog[open]');
        if (show === this.visible) return;
        this.visible = show;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
        if (show) document.documentElement.style.setProperty('--toast-offset', this.offsetHeight + 'px');
        else document.documentElement.style.removeProperty('--toast-offset');
      }

      syncPickers(event) {
        const options = event.detail && event.detail.options;
        if (!options || !this.root) return;
        this.root.querySelectorAll('variant-picker').forEach((picker) => {
          picker.querySelectorAll('fieldset[data-option-index]').forEach((fieldset) => {
            const value = options[parseInt(fieldset.getAttribute('data-option-index'), 10)];
            fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
              if (input.value === value && !input.checked) input.checked = true;
            });
          });
          if (typeof picker.updateAvailability === 'function') picker.updateAvailability();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var clear = event.target.closest('[data-search-clear]');
    if (!clear) return;
    var input = clear.parentElement.querySelector('input[type="search"]');
    if (!input) return;
    input.value = '';
    clear.hidden = true;
    input.focus();
  });
  document.addEventListener('input', function (event) {
    if (!event.target.matches('.search-field__input')) return;
    var clear = event.target.parentElement.querySelector('[data-search-clear]');
    if (clear) clear.hidden = event.target.value === '';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-overlay"]) return;
  try {
    
  if (!customElements.get('predictive-search')) {
    class PredictiveSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-predictive-results]');
        this.live = this.querySelector('[data-predictive-live]');
        this.dialog = this.closest('dialog');
        this.initial = this.results ? this.results.innerHTML : '';
        this.cache = {};
        this.url = this.dataset.url;
        if (!this.input) return;
        this.onInput = this.onInput.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.input.addEventListener('input', this.onInput);
        this.input.addEventListener('keydown', this.onKeydown);
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('mousemove', this.onHover.bind(this));
        if (this.dialog) {
          this.dialog.addEventListener('close', this.onClose.bind(this));
        }
        if (!window.__aromaSearchKey) {
          window.__aromaSearchKey = true;
          document.addEventListener('keydown', function (event) {
            if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey) return;
            var target = event.target;
            if (target.closest('input, textarea, select, [contenteditable="true"]') || document.querySelector('dialog[open]')) return;
            var dialog = document.getElementById('SearchDialog');
            if (!dialog) return;
            event.preventDefault();
            if (window.Aroma && window.Aroma.openDialog) window.Aroma.openDialog(dialog);
            else dialog.showModal();
          });
        }
      }

      onInput() {
        var self = this;
        clearTimeout(this.timer);
        var query = this.input.value.trim();
        this.classList.toggle('has-query', query.length > 0);
        if (!query) { this.reset(); return; }
        if (!this.url) return;
        this.timer = setTimeout(function () { self.search(query); }, 180);
      }

      search(query) {
        var self = this;
        if (this.cache[query]) { this.render(this.cache[query]); return; }
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        this.classList.add('is-loading');
        var params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'product,collection,page,article,query');
        params.set('resources[limit]', '6');
        params.set('resources[limit_scope]', 'each');
        params.set('section_id', this.dataset.section);
        fetch(this.url + '?' + params.toString(), { signal: this.controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var content = doc.querySelector('[data-predictive-content]');
            var markup = content ? content.outerHTML : '';
            self.cache[query] = markup;
            if (self.input.value.trim() === query) self.render(markup);
          })
          .catch(function (error) {
            if (error.name !== 'AbortError') self.reset();
          })
          .finally(function () { self.classList.remove('is-loading'); });
      }

      render(markup) {
        this.results.innerHTML = markup;
        this.classList.add('has-results');
        var options = this.options();
        this.input.setAttribute('aria-expanded', options.length > 0 ? 'true' : 'false');
        this.input.removeAttribute('aria-activedescendant');
        var status = this.results.querySelector('[data-predictive-status]');
        if (this.live && status) this.live.textContent = status.textContent;
        this.results.querySelectorAll('.predictive__option').forEach(function (option, index) {
          option.style.setProperty('--i', index);
        });
      }

      reset() {
        if (this.controller) this.controller.abort();
        this.results.innerHTML = this.initial;
        this.classList.remove('has-results', 'is-loading');
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }

      options() {
        return Array.prototype.slice.call(this.results.querySelectorAll('[role="option"]'));
      }

      select(option) {
        this.options().forEach(function (item) { item.setAttribute('aria-selected', item === option ? 'true' : 'false'); });
        if (option) {
          this.input.setAttribute('aria-activedescendant', option.id);
          option.scrollIntoView({ block: 'nearest' });
        } else {
          this.input.removeAttribute('aria-activedescendant');
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.dialog) {
          event.preventDefault();
          if (window.Aroma && window.Aroma.closeDialog) window.Aroma.closeDialog(this.dialog);
          else this.dialog.close();
          return;
        }
        var options = this.options();
        if (!options.length) return;
        var current = options.findIndex(function (option) { return option.getAttribute('aria-selected') === 'true'; });
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.select(options[(current + 1) % options.length]);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.select(options[current <= 0 ? options.length - 1 : current - 1]);
        } else if (event.key === 'Enter' && current > -1) {
          var link = options[current].querySelector('a');
          if (link) { event.preventDefault(); window.location.href = link.href; }
        }
      }

      onHover(event) {
        var option = event.target.closest('[role="option"]');
        if (option && option.getAttribute('aria-selected') !== 'true') this.select(option);
      }

      onClick(event) {
        var chip = event.target.closest('[data-suggestion]');
        if (!chip || !this.url) return;
        event.preventDefault();
        this.input.value = chip.getAttribute('data-suggestion');
        this.input.focus();
        this.onInput();
      }

      onClose() {
        clearTimeout(this.timer);
        if (this.controller) this.controller.abort();
      }
    }
    customElements.define('predictive-search', PredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();
})();
